/* eslint-disable jsx-a11y/heading-has-content */
/**
 * @file   图片详情页
 * @create macaiqi 2021/11/29
 * @update
 */
 import React, { useEffect, useRef, useState } from 'react';
 import { Link, useLocation, useHistory } from 'react-router-dom';
 // import Slider from '@ant-design/react-slick';
 import 'swiper/swiper.scss';
 import cls from 'classnames';
 import { queryPicList,queryInstanceDetails } from '../../../shared/api';
 import { GetQueryString } from '../../../../utils';
 import { PictureViewer } from './bigImgView';
 import './index.scss';
 import Star from '../../common/Star';
 import defaultImg from '@/assets/images/desktop/imgdetail/imgView.png'
 const iiifPre = window.iiifApi;
 // http://122.112.235.243:8282/iiif/2/+图片路径+/info.json
 const BigImgShow = (params) => {
   // 图像检索页面：默认展示奕世尚书坊的图像标记信息
   const initInstanceId = '57ccc05a161fb14a231987512989b2f2';
   const initFileInfoId = 'c462bac9aa834992bd19ae443d204f03';
   const history = useHistory();
   const pv = useRef(null);
   const { pathname } = useLocation();
   const [iiifdata, setiiifdata] = useState([]);
   const [instanceId, setInstanceId] = useState(); // 实例id列表
   const [fileInfoId, setfileInfoId] = useState([]); // 图片id列表
   const [initialPage, setinitialPage] = useState(); // 当前图片索引
   const [showInstanceDetail,setShowInstanceDetail] = useState(true);  // 是否展示实例描述
   const [instanceData,setInstanceData] = useState(null);
   const [currentFileInfoId,setCurrentFileInfoId] = useState();  // 当前图像id
   const [hasMarks,setHasMarks] = useState();  // 当前图像id
   useEffect(() => {
     // const url = new URLSearchParams(search);
     let dafileInfoIdnew = [];
     let iiifdatanew = [];
 
     let instanceId = params.isInitImg ? initInstanceId : pathname.split('/').reverse()[0];
     setInstanceId(instanceId);
     let selectFileInfoId = params.isInitImg ? initFileInfoId : GetQueryString('fileInfoId');
     let isHasMark = GetQueryString('hasMark');
     isHasMark = isHasMark && isHasMark == '1' ? true : false;
     setHasMarks(isHasMark);
     setCurrentFileInfoId(selectFileInfoId);
     queryPicList({
       current: 1,
       fileName: '',
       instanceId: instanceId,
       size: 99
     }).then((res) => {
       for (let i = 0; i < res.records.length; i++) {
         iiifdatanew.push(
          iiifPre+`${res.records[i].filePath.replace(/\/\//g, '/').replace(/\//g, '%2F')}/info.json`
         );
         dafileInfoIdnew.push(res.records[i].fileInfoId);
         // 如果有传入的当前图片id,判断在第几张，默认选中
         if (res.records[i].fileInfoId === selectFileInfoId) {
           setinitialPage(i);
         }
       }
       setfileInfoId(dafileInfoIdnew); // 实例的每张图的id
       setiiifdata(iiifdatanew);
     });
     // return () => {
     //   pv.current?.destroy();
     // };
     // eslint-disable-next-line react-hooks/exhaustive-deps
     if(params.isInitImg){
      //  查询图片所属实例
      queryInstanceDetails({
        attrEnglishCodes: ['description'],
        instanceId: instanceId
      }).then((res) => {
        if (res) {
          setInstanceData(res);
        }
      });
     }
   }, []);
   useEffect(() => {
     if (iiifdata.length > 0) {
       pv.current = new PictureViewer(
         document.getElementById('pic'),
         instanceId,
         fileInfoId,
         initialPage,
         params.isInitImg
       );
       pv.current.init(iiifdata);
     }
   }, [fileInfoId, initialPage, iiifdata, pathname]);
   return (
     <div className="mw-content-text bigImgViewPage">
       <div className="content-begin">
         {/* 标记列表 */}
         { !params.isInitImg && <div id="marklist">
           <div className="scroll" />
         </div>}

         {/* 实例描述 */}
         {
          params.isInitImg && showInstanceDetail && instanceData && <div id="instanceDetail">
           <div className='closeBtn' onClick={()=>setShowInstanceDetail(false)}>×</div>
           <h3>{instanceData?.instanceName}</h3>
            <div className='desc' dangerouslySetInnerHTML={{
            __html: instanceData?.properties?.description
            }} />
          </div>
         }
         
         {/* <!-- 图像区域 -- 开始 --> */}
         <div id="pic">
           {/* <!-- 左下角按钮组 -- 开始 --> */}
           { !params.isInitImg && hasMarks && <div className="controls">
             <div id="fitWh" className="ctrl_btn full" />
             <div id="zoomIn" className="ctrl_btn" />
             <div id="zoomOut" className="ctrl_btn" />
             <Star operationType = '2' instanceId={instanceId} fileInfoId={currentFileInfoId}/>
             {/* <div id="collect" className="ctrl_btn" />
             <div id="thumb" className="ctrl_btn" />
             <div id="share" className="ctrl_btn" /> */}
           </div>}
           
           {/* <!-- 右下角按钮组 -- 结束 --> */}
 
           {/* <!-- 标记详情弹框 -- 开始 --> */}
           <div className="markDetail">
             <span className="close">×</span>
             <div className="markData">
               <h3 />
               <p />
               <div className="knowledgebox knowledgebox1">
                 <div className="knowledge">相同元素</div>
                 <div className="knowledgeitem knowledgeitem1">
                   <div className="slick-arrow prev disable">
                     <i className={cls('iconfont', 'icon-zuo')} />
                   </div>
                   <div className="wrap wrap1">
                     {/* <div className="item">
                     <div className="img" />
                     <div className="title">111</div>
                   </div>
 
                   <div className="item">
                     <div className="img" />
                     <div className="title">111</div>
                   </div>
                   <div className="item">
                     <div className="img" />
                     <div className="title">111</div>
                   </div>
                   <div className="item">
                     <div className="img" />
                     <div className="title">111</div>
                   </div> */}
                   </div>
                   <div className="slick-arrow next">
                     <i className={cls('iconfont', 'icon-you')} />
                   </div>
                 </div>
               </div>
               <div className="knowledgebox knowledgebox2">
                 <div className="knowledge">知识扩展</div>
                 <div className="knowledgeitem knowledgeitem2">
                   <div className="slick-arrow prev disable">
                     <i className={cls('iconfont', 'icon-zuo')} />
                   </div>
                   <div className="wrap wrap2">
                     {/* <div className="item">
                     <div className="img" />
                     <div className="title">111</div>
                   </div>
 
                   <div className="item">
                     <div className="img" />
                     <div className="title">111</div>
                   </div>
                   <div className="item">
                     <div className="img" />
                     <div className="title">111</div>
                   </div>
                   <div className="item">
                     <div className="img" />
                     <div className="title">111</div>
                   </div> */}
                   </div>
                   <div className="slick-arrow next">
                     <i className={cls('iconfont', 'icon-you')} />
                   </div>
                 </div>
               </div>
 
               {/* <Slider {...settings} className="knowledgeitem">
                 <div className="item">
                   <div className="img" />
                   <div className="title">111</div>
                 </div>
 
                 <div className="item">
                   <div className="img" />
                   <div className="title">111</div>
                 </div>
                 <div className="item">
                   <div className="img" />
                   <div className="title">111</div>
                 </div>
                 <div className="item">
                   <div className="img" />
                   <div className="title">111</div>
                 </div>
               </Slider> */}
               {/* <div className="bottomBtns" /> */}
             </div>
           </div>
           {/* <!-- 标记详情弹框 -- 结束 --> */}
         </div>
         {/* <!-- 图像区域 -- 结束 --> */}
 
         {/* <!-- 标记语音导航 -- 开始 --> */}
         <audio controls="controls" id="markAudio" hidden>
           <source src="" type="audio/mpeg" />
           您的浏览器暂不支持播放
         </audio>
         {/* <!-- 标记语音导航 -- 结束 --> */}
    
         {/* <!-- 相同元素模块预览 -- 开始 -->  */}
         <div id='viewBg'>
           <div className='sameElmentView'>
              <div className='viewHead'>
                <span className='title'/>
                <a href="/Subject/HistoricalBuilding/1">查看完整图像</a>
              </div>
              <div className='viewContent'>
                <div className='prev'>
                  <i className='iconfont icon-zuo'/>
                </div>
                <div className='imgView'>
                  <img src={defaultImg}/>
                </div>
                <div className='prev'>
                  <i className='iconfont icon-you'/>
                </div>
              </div>
           </div>
         </div>
         {/* <!-- 相同元素模块预览 -- 结束 -->  */}

 
         {/* <!-- 左侧按钮组 -- 开始 --> */}
         {/* <aside id="page_menu">
           <div className="controls">
             <Link to="/" id="home" className="ctrl_btn" />
             <div
               id="back"
               className="ctrl_btn"
               onClick={() => {
                 history.goBack();
               }}
             />
           </div>
         </aside> */}
         {/* <!-- 左侧按钮组 -- 结束 --> */}
 
         {/* <!-- 右侧内容 -- 开始 --> */}
         {/* <aside id="viewer_menu" className="viewer_menu thinMode closed">
           <div className="controls">
             <div id="fitWh" className="ctrl_btn full" />
             <div id="zoomIn" className="ctrl_btn" />
             <div id="zoomOut" className="ctrl_btn" />
             <div id="detail" className="ctrl_btn" />
           </div>
 
           <div id="about_info" className="about">
             <div className="mark_info">
               <div className="searchModule">
                 <div className="searchBox">
                   <input type="text" name="markName" autoComplete="off" />
                   <div className="clearBtn" />
                   <div className="searchBtn" />
                 </div>
                 <p className="notFound">
                   当前图片尚未标记条目
                   <span className="name" />
                 </p>
                 <div className="searchResult">
                   <div className="searchList scroll_bar" />
                   <div className="searchPages">
                     <div className="lastPageBtn pageBtn">上一页</div>
                     <div className="currentPage">
                       <span className="current" /> / <span className="pages" />
                     </div>
                     <div className="nextPageBtn pageBtn">下一页</div>
                   </div>
                 </div>
               </div>
             </div>
             <div className="img_info">
               <div className="content scroll_bar">
                 <div id="picture_detail" style={{ display: 'block' }}>
                   <div id="picture_info">
                   </div>
                 </div>
               </div>
               <div className="relative" id="relative">
                 <h1 className="relativeTitle">相关推荐</h1>
                 <div className="relativeSlideBox">
                   <div className="relativeSlideLeft disable">
                     <i className="iconfont icon-zuo" aria-hidden="true" />
                   </div>
                   <div className="relativeSlideContent" />
                   <div className="relativeSlideRight">
                     <i className="iconfont icon-you" aria-hidden="true" />
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </aside> */}
         {/* <!-- 右侧内容 -- 结束 --> */}
       </div>
     </div>
   );
 };
 export default BigImgShow;
 